import type { NodeRef } from "../engine/types.ts";
import type { CosmosData, GalaxyMeta } from "../parser/types.ts";

export interface SearchCallbacks {
  query: (q: string) => NodeRef[];
  onPick: (id: string) => void;
}

/** Busca instantânea: dropdown ao vivo, navegável por teclado (↑ ↓ Enter Esc). */
export class Search {
  private input!: HTMLInputElement;
  private list!: HTMLElement;
  private results: NodeRef[] = [];
  private active = -1;

  constructor(private data: CosmosData, private cb: SearchCallbacks) {}
  setData(d: CosmosData) { this.data = d; }

  mount(root: HTMLElement) {
    root.insertAdjacentHTML(
      "beforeend",
      `<div id="search">
        <input id="q" placeholder="buscar no cosmos…   /" autocomplete="off" spellcheck="false" />
        <div id="search-results"></div>
      </div>`,
    );
    this.input = root.querySelector("#q") as HTMLInputElement;
    this.list = root.querySelector("#search-results") as HTMLElement;
    this.input.addEventListener("input", () => this.run());
    this.input.addEventListener("keydown", (e) => this.key(e));
    this.input.addEventListener("focus", () => { if (this.input.value) this.run(); });
    this.input.addEventListener("blur", () => setTimeout(() => this.close(), 150));
    this.list.addEventListener("mousedown", (e) => {
      const t = (e.target as HTMLElement).closest("[data-id]") as HTMLElement | null;
      if (t?.dataset.id) { e.preventDefault(); this.pick(t.dataset.id); }
    });
  }

  focus() { this.input.focus(); this.input.select(); }

  private galColor(g: string): string {
    return (this.data.gal as Record<string, GalaxyMeta>)[g]?.color ?? "#8893ad";
  }
  private run() {
    const q = this.input.value.trim();
    if (!q) { this.close(); return; }
    this.results = this.cb.query(q).slice(0, 8);
    this.active = this.results.length ? 0 : -1;
    this.render();
  }
  private render() {
    if (!this.results.length) { this.close(); return; }
    this.list.innerHTML = this.results
      .map((r, i) =>
        `<div class="sr-item${i === this.active ? " active" : ""}" data-id="${esc(r.id)}"><span class="d" style="background:${this.galColor(r.gal)}"></span><span class="sr-label">${esc(r.label)}</span></div>`,
      )
      .join("");
    this.list.classList.add("open");
  }
  private key(e: KeyboardEvent) {
    if (e.key === "ArrowDown") { e.preventDefault(); this.active = Math.min(this.results.length - 1, this.active + 1); this.render(); }
    else if (e.key === "ArrowUp") { e.preventDefault(); this.active = Math.max(0, this.active - 1); this.render(); }
    else if (e.key === "Enter") { const r = this.results[this.active]; if (r) this.pick(r.id); }
    else if (e.key === "Escape") { this.input.value = ""; this.close(); this.input.blur(); }
  }
  private pick(id: string) { this.cb.onPick(id); this.close(); this.input.blur(); }
  private close() { this.list.classList.remove("open"); this.list.innerHTML = ""; }
}

function esc(s: string): string {
  return s.replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c] as string));
}
